import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './loader.module.css';

const Loader = ({color, className}) => (
  <div
    className={clsx(styles.loader, className)}
    style={{borderTopColor: color}}
  />
);

Loader.defaultProps = {
  color: '#212121',
  className: ''
};

Loader.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string
};

export default Loader;
